import { TURNSTILE_SITE_KEY } from '@/env'
import { useUiKit } from '@/ui-kit/providers'
import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile'
import { forwardRef, useImperativeHandle, useRef } from 'react'

export type TurnstileWidgetProps = {
  action: string
  onToken: (token: string) => void
  onExpire?: () => void
  onError?: () => void
  className?: string
}

export type TurnstileWidgetHandle = {
  reset: () => void
}

export const TurnstileWidget = forwardRef<TurnstileWidgetHandle, TurnstileWidgetProps>(
  ({ action, onToken, onExpire, onError, className }, ref) => {
    const innerRef = useRef<TurnstileInstance | null>(null)
    const { isThemeDark } = useUiKit()

    useImperativeHandle(ref, () => ({
      reset: () => {
        innerRef.current?.reset()
      }
    }))

    if (!TURNSTILE_SITE_KEY) return null

    return (
      <div className={className}>
        <Turnstile
          ref={innerRef}
          siteKey={TURNSTILE_SITE_KEY}
          options={{
            action,
            size: 'flexible',
            appearance: 'interaction-only',
            theme: isThemeDark ? 'dark' : 'light'
          }}
          onSuccess={onToken}
          onExpire={onExpire}
          onError={onError}
        />
      </div>
    )
  }
)

TurnstileWidget.displayName = 'TurnstileWidget'
